import { FETCH_NO_LOAD_REPORT } from 'actions/noLoadReport';

const initialState = {
  isLoading: false,
  noLoadReports: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const noLoadReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_NO_LOAD_REPORT.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_NO_LOAD_REPORT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        noLoadReports: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case FETCH_NO_LOAD_REPORT.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default noLoadReportReducer;
